import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const Section = ({ sectionId, className, children }) => (
    <div id={sectionId} className={classnames('section', className)}>
            {children}
    </div>
)

Section.propTypes = {
    sectionId: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired 
}

export default Section